import VueShowMoreText from "./components/VueShowMoreText.vue";

export default VueShowMoreText;